import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicModal from '../../Components/Modal_Basic';
import CkeckingForm from '../../Components/CkeckingForm';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import Commons from '../../Services/Common/Common';
import Dialog from '../../Services/Common/Dialog';
import IndexedDb from '../../Services/IndexedDb/IndexedDb';
/** Components Import */
import Snackbar from '../../Components/Snackbar';
/** Drawer Import */
import { DrawerActions } from '../../Reducers/DrawerReducer';

function BM10090(props) {
    const drawerStates = useSelector((state) => state.Drawer); // Drawer Redux 호출
    const gridRef = React.useRef();
    //그리드 컬럼
    const columnDefs = [
        {
            field: 'plantCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ChangePS' && f.lanType === 'COL')[0].lanName
                    : '', //사업장코드
            minWidth: 150,
            editable: false,
            hide: true,
        },
        {
            field: 'whCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhCd' && f.lanType === 'COL')[0].lanName
                    : '', //창고코드
            headerCheckboxSelection: true,
            checkboxSelection: true,
            editable: false,
        },
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '', //창고명
        },
        {
            field: 'whGubunNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhGubunNm' && f.lanType === 'COL')[0].lanName
                    : '', //창고구분
            cellEditor: 'agSelectCellEditor',
            editable: true,
            cellEditorParams: {
                values: props.inputs.comboList,
                default: props.inputs.comboValue,
            },
            valueParser: (params) => {
                return props.inputs.comboValue;
            },
            valueFormatter: (params) => {
                if (params.value == undefined) {
                    return null;
                } else {
                    return params.value.name;
                }
            },
            editable: true,
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
            editable: false,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            editable: false,
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
            editable: false,
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            editable: false,
        },
    ];
    const [modalToggle, setModalToggle] = React.useState(false); //코드 체크 팝업

    React.useEffect(() => {
        document.title = '창고관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>창고관리</strong>" +
            '</h1>';
        let a = props.rowData;
        if (props.checkInputs.result) {
            gridRef.current.api.setRowData([
                {
                    whCd: props.checkInputs.whCd,
                    newYn: 'Y',
                },
                ...props.rowData,
            ]);
            props.setSaveData([
                {
                    whCd: props.checkInputs.whCd,
                },
            ]);
            // a.unshift({
            //   groupCd: props.checkInputs.groupCode,
            //   code: props.checkInputs.code,
            //   createDate: "",
            //   createId: "",
            //   sortSeq: 0,
            //   name: "",
            //   ref1: "",
            //   ref2: "",
            //   ref3: "",
            //   val1: null,
            //   val2: null,
            //   val3: null,
            //   updateDate: "",
            //   updateId: "",
            //   newYn: "Y",
            // });
            // props.setRowData(a);
            props.setCheckInputs({
                ...props.checkInputs,
                whCd: '',
                result: false,
            });
        }
    }, [props.checkInputs.result]);

    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                {/* 그리드 버튼 */}
                <AuthGroupButton
                    pageName="BM10090"
                    target="G01"
                    selectFunc={() => {
                        props.Init();
                    }}
                    refreshNone="none"
                    addFunc={() => setModalToggle(true)}
                    saveFunc={() => props.SaveConfirm()}
                    deleteFunc={() => props.DeleteConfirm()}
                />
            </Card>
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                {/* 그리드  */}
                <AgGridReact
                    ref={gridRef}
                    animateRows={true}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        flex: 1,
                        minWidth: 100,
                        editable: true,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                    }}
                    rowData={props.rowData}
                    rowSelection="multiple"
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    onCellValueChanged={(e) => {
                        GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData);
                    }}
                    getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                />
            </div>
            {/* 코드 체크 팝업 */}
            {modalToggle && (
                <BasicModal
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_CodeManagement' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : '' //코드관리
                    }
                    onClose={() => setModalToggle(false)}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0].lanName
                            : '' //검사
                    }
                    execLogic={() => props.CheckKeys()}
                >
                    <CkeckingForm
                        datas={[
                            // {
                            //   type: "combo",
                            //   combos: props.checkInputs.comboPlantCd,
                            //   name:
                            //     props.lanData.length > 0
                            //       ? props.lanData.filter(
                            //           (f) => f.lanId === "Col_PlantCd" && f.lanType === "COL"
                            //         )[0].lanName
                            //       : "", //사업장코드
                            //   value: props.checkInputs.plantCd,
                            //   onChange: (e) => {
                            //     props.setCheckInputs({
                            //       ...props.checkInputs,
                            //       plantCd: e,
                            //     });
                            //   },
                            // },
                            {
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter((f) => f.lanId === 'Col_WhCd' && f.lanType === 'COL')[0]
                                              .lanName
                                        : '', //창코코드
                                value: props.checkInputs.whCd,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        whCd: e.target.value,
                                    });
                                },
                            },
                        ]}
                    />
                </BasicModal>
            )}
        </div>
    );
}

export default BM10090;
